"use strict";

/**
 * Init Google Recaptcha
 * @param {function} callback - callback function
 * @returns {void}
 */
const initRecaptcha = (callback) => {
    const recaptchaKey = document.getElementById("recaptchaKey")?.value;

    if (window.grecaptcha) {
        grecaptcha.ready(function () {
            grecaptcha.execute(recaptchaKey, {
                action: "submit"
            }).then(function (token) {
                callback(token);
            });
        });
    } else {
        callback("");
    }
};

/**
 * Creates a hidden input element with the given token value for reCAPTCHA response
 * @param {string} token - the reCAPTCHA token value
 * @returns {HTMLInputElement} - a hidden input element with the reCAPTCHA token value
 */
const createInputResponse = (token) => {
    const input = document.createElement("input");
    input.value = token;
    input.type = "hidden";
    input.className = "captcha-response";
    input.name = "g-recaptcha-response";

    return input;
};

module.exports = {
    initRecaptcha: initRecaptcha,
    createInputResponse: createInputResponse
};
